import React from 'react';
import { ChatBubble } from '@amzn/awsui-chat-components-console';
import ChatBubbleAvatar from '../ChatInterface/ChatBubbleAvatar';
import { ThinkingPanel } from '../../chat';
import { StreamingMessage } from '../ChatInterface/AgentComponents';
import { toolStepToThinkingStep } from '../../chat/adapters';
import AnimatedDots from './AnimatedDots';
import type { AgentStreamState } from '../../../types/agent-messages';

interface LiveAgentMessageProps {
  streamState: AgentStreamState;
}

const LiveAgentMessage: React.FC<LiveAgentMessageProps> = ({ streamState }) => {
  const { phase, toolSteps, streamedText } = streamState;

  if (phase === 'idle' || phase === 'complete' || phase === 'error') return null;

  const isStreaming = phase === 'thinking' || phase === 'toolRunning' || phase === 'streaming';
  const thinkingSteps = toolSteps.map(toolStepToThinkingStep);
  const showBubble = phase === 'streaming' || !!streamedText;

  return (
    <div className="message-wrapper message-incoming">
      <div className="agent-response-group">
        {toolSteps.length > 0 && (
          <div className="thinking-section">
            <ThinkingPanel
              steps={thinkingSteps}
              isStreaming={isStreaming}
            />
          </div>
        )}
        {showBubble ? (
          <ChatBubble
            avatar={<ChatBubbleAvatar type="assistant" name="ADDAPT Intelligence" />}
            ariaLabel="ADDAPT Intelligence is responding"
            type="incoming"
          >
            <StreamingMessage
              text={streamedText}
              isStreaming={phase === 'streaming'}
            />
          </ChatBubble>
        ) : (
          <ChatBubble
            avatar={<ChatBubbleAvatar type="assistant" name="ADDAPT Intelligence" loading />}
            ariaLabel="ADDAPT Intelligence is thinking"
            type="incoming"
          >
            <span style={{ color: '#5f6b7a', fontSize: '13px' }}>Working on it<AnimatedDots /></span>
          </ChatBubble>
        )}
      </div>
    </div>
  );
};

export default LiveAgentMessage;
